// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"761":"8b596e94","924":"33f63c70"}[chunkId] + ".js";
};